import React from 'react';
import './AdvisorNotice.css';

/*
 * The line a lead sees before they say anything.
 *
 * Shown above the composer, not in a dismissed banner or a link to a policy
 * page: someone about to type their budget and phone number should already know
 * where it goes. Wording comes from the server so it cannot drift from what the
 * backend actually does with the data.
 *
 * It stays visible for the whole conversation rather than being dismissible.
 * The moment it matters most is when they type their phone number, which is
 * rarely the first message.
 */
export default function AdvisorNotice({ text }) {
  if (!text) return null;
  return (
    <p className="advisor-notice" role="note">
      <span className="advisor-notice__dot" aria-hidden="true" />
      {text}
    </p>
  );
}
